var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"color-sample s1-east"},[_c('section',[_c('p',{staticClass:"small-text"},[_vm._v("\n      享年 八十八歳\n    ")])])])}]

export { render, staticRenderFns }